
import Layout from '@/components/layout/Layout';
import BlueskyAuth from '@/components/auth/BlueskyAuth';

const Login = () => {
  return (
    <Layout fullHeight>
      <div className="w-full flex-1 flex flex-col items-center justify-center p-6">
        <h1 className="text-3xl font-display font-bold mb-6 text-center">Agents of Learning: Historical Figures</h1>
        <p className="text-muted-foreground mb-8 text-center max-w-md">
          Sign in with your Bluesky account to converse with America's founding fathers and influential historical figures
        </p>
        <BlueskyAuth />
      </div>
    </Layout>
  );
};

export default Login;
